import axios from 'axios'


var API_KEY = '9dbde76d6a3b406c81e5dee6c2363c3a'
var API_URL = 'https://api.opencagedata.com/geocode/v1/json';


const getLocationName = async(latitude, longitude) => {

    let locationName = `${latitude} , ${longitude}`;

    let requestUrl = buildRequestUrl(latitude, longitude);

    try{
        let response = await axios.get(requestUrl);

        if(response){
            locationName = BuildLocationNam(response.data.results[0]);
        }
    }
    catch(err){
        return { errorMsg : err.message}
    }

    return locationName;
}

function BuildLocationNam(result){
    if(result.formatted != ""){
        return result.formatted;
    }else if(result.components.town != "" && result.components.country != ""){
        return `${result.components.town} , ${result.components.country}`;
    }
    else{
        return `My Location`
    }
}

function buildRequestUrl(latitude, longitude) {
    return  API_URL 
        + '?' 
        + 'key=' + API_KEY 
        + '&q=' + encodeURIComponent (latitude + ',' + longitude) 
        + '&language=en' 
        + '&pretty=1'
        + '&no_annotations=1';
}

export default {getLocationName}